import styled from '@emotion/styled'
import tw from 'twin.macro'
import { Heading as DefaultHeading } from '@pretamanger/component-library'

export const Wrapper = styled.div`
  ${tw`bg-white`}
`

export const Heading = styled(DefaultHeading)`
  ${tw`text-2xl leading-2xl tracking-lg md:text-3xl md:leading-3xl md:tracking-lg mb-2`}
`

export const SubHeading = styled.p`
  ${tw`mb-2`}
`

export const Option = styled.div`
  > div {
    ${tw`border-0`}
  }
  ${props => props.isDefault && tw`border-b-2`}
`

export const DefaultOption = styled.div`
  ${tw`h-8 flex flex-col justify-center items-start px-3 py-6`}
`
